<app-add-form
  data-testid="purchase-return-order-add-form"
  #addForm
  [title]="'purchase_return_order.add.title' | translate"
  [formFields]="formFields()"
  [tableSections]="tableSections()"
  [headerActions]="headerActions()"
  [loading]="false"
  [initialData]="currentFormData"
  [getFieldError]="getDetailFieldError.bind(this)"
  (formAction)="onFormAction($event.action)"
  (tableAction)="onTableAction($event)"
  (formValueChanges)="onFormValueChanges($event)"
>
  <!-- Actions Template for Item Details table - always show to allow deleting individual records -->
  <ng-template #actionsTemplate let-rowData>
    <div class="flex gap-2 justify-center">
      <span
        [attr.data-testid]="'purchase-return-order-add-action-delete-item-' + rowData.id"
        (click)="onDeleteItem(rowData)"
        class="action-link action-delete cursor-pointer"
      >
        {{ "common.actions.delete" | translate }}
      </span>
    </div>
  </ng-template>
</app-add-form>

<!-- Stock Selection Dialog -->
<app-rtv-stock-selection-dialog
  data-testid="purchase-return-order-add-stock-selection-dialog"
  [visible]="showStockDialog()"
  (visibleChange)="showStockDialog.set($event)"
  [warehouseCode]="dialogWarehouseCode()"
  [existingSkuCodes]="existingSkuCodes()"
  [skuCodes]="vendorSkuCodes()"
  (confirm)="onStockDialogConfirm($event)"
></app-rtv-stock-selection-dialog>

<!-- Toast Messages -->
<p-toast data-testid="purchase-return-order-add-toast"></p-toast>

